/**
 * @generated SignedSource<<d88325506357ec4f119083c331e9b722>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskDeleteInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type RemoveTask_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: TaskDeleteInput;
};
export type RemoveTask_Mutation$data = {
  readonly deleteTask: {
    readonly deletedTaskIds: ReadonlyArray<string>;
  };
};
export type RemoveTask_Mutation = {
  response: RemoveTask_Mutation$data;
  variables: RemoveTask_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedTaskIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveTask_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TaskDeletePayload",
        "kind": "LinkedField",
        "name": "deleteTask",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RemoveTask_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TaskDeletePayload",
        "kind": "LinkedField",
        "name": "deleteTask",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedTaskIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "204e5c7af2ccf2177b2480d7cf61c110",
    "id": null,
    "metadata": {},
    "name": "RemoveTask_Mutation",
    "operationKind": "mutation",
    "text": "mutation RemoveTask_Mutation(\n  $input: TaskDeleteInput!\n) {\n  deleteTask(input: $input) {\n    deletedTaskIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "bee6566df8be4f842e14f79e82799433";

export default node;
